import type { FC } from "react";
import React, { Suspense } from "react";
import { CircularProgress } from "@material-ui/core";

import ErrorBoundary from "../../../../basic/error_boundary";
import { WeeklyRating } from "../weekly_rating/weekly_rating";

export const WeeklyRatingSuspense: FC = () => (
    <ErrorBoundary>
        <Suspense fallback={<CircularProgress />}>
            <WeeklyRating />
        </Suspense>
    </ErrorBoundary>
);
